import React, { useEffect, useState } from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import { getVariableList } from "../Redux/Slice/Assistant/GetVariableListSlice";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../Common/useDebounce";
import { Loader } from "../Common/Loader";
import PlusIcon from "../Assets/svgs/PlusIcon.";
import CloseGreyIcon from "../Assets/svgs/CloseGreyIcon";
import { DEFAULT_MERGE_FIELDS } from "../Common/Constants";

const AddVariableModal = ({ assistantId, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 500);
  const [loading, setLoading] = useState(false);
  const [selectedVariables, setSelectedVariables] = useState([]);
  const [allVariables, setAllVariables] = useState([]);

  const onAddVariable = (selectedVariable) => {
    const isAlreadyExists = selectedVariables?.some(
      (variable) => variable?.id == selectedVariable?.id
    );
    if (!isAlreadyExists) {
      setSelectedVariables((prev) => [...prev, selectedVariable]);
      setAllVariables((prev) =>
        prev?.filter((variable) => variable?.id != selectedVariable?.id)
      );
    }
  };

  const onRemoveVariable = (selectedVariable) => {
    setSelectedVariables((prev) =>
      prev?.filter((variable) => variable?.id != selectedVariable?.id)
    );
    setAllVariables((prev) => [...prev, selectedVariable]);
  };

  const handleSubmit = () => {
    const variablesText = ` ${selectedVariables
      ?.map((variable) => variable?.name)
      ?.join(" ")} `;
    onSubmit(variablesText);
  };

  const getVariablesList = async () => {
    if (!assistantId) {
      setAllVariables(
        DEFAULT_MERGE_FIELDS.filter(
          (item) => item.name.toLowerCase().includes(debouncedSearchText.toLowerCase())
        )
      );
      return;
    }
    setLoading(true);
    try {
      const result = await dispatch(
        getVariableList({ assistantId, keyword: debouncedSearchText })
      );
      if (
        getVariableList.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        const data = Array.isArray(result?.payload.data)
          ? result.payload.data
          : [];
        setAllVariables(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVariablesList();
  }, [assistantId, debouncedSearchText]);

  return loading ? (
    <Loader />
  ) : (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header ">
            <h1 className="modal__header--title">Add Variables</h1>
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="createFormGrid">
              <div className="createFormGrid__row">
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <input
                        type="text"
                        id="SearchaVariable"
                        className="form__input form__input--search form__input--sm"
                        placeholder="Search a Variable"
                        value={searchText}
                        onChange={(e) => setSearchText(e?.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {Array.isArray(selectedVariables) && selectedVariables?.length ? (
                <div className="createFormGrid__row">
                  <h3 className="title title--h5">Selected Variables</h3>
                  <div className="formRow">
                    <div className="formCol">
                      <ul className="variablesList">
                        {Array.isArray(selectedVariables) &&
                          selectedVariables?.map((variable) => (
                            <li
                              className="variablesList__item"
                              key={`${variable?.id}`}
                            >
                              <button
                                className="selectedVariableBtn"
                                onClick={() => onRemoveVariable(variable)}
                              >
                                <CloseGreyIcon />
                                {variable?.name}
                              </button>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="createFormGrid__row">
                <h3 className="title title--h5">Available Variables</h3>
                <div className="formRow">
                  <div className="formCol">
                    <ul className="variablesList">
                      {Array.isArray(allVariables) && allVariables?.length ? (
                        allVariables?.map((variable) => (
                          <li
                            className="variablesList__item"
                            key={`${variable?.id}`}
                          >
                            <button
                              className="availableVariableBtn"
                              onClick={() => onAddVariable(variable)}
                            >
                              <PlusIcon />
                              {variable?.name}
                            </button>
                          </li>
                        ))
                      ) : (
                        <div className="no-data">No Variable Found!</div>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={onClose}>
                Cancel
              </button>
              <button
                disabled={!selectedVariables?.length}
                className="btn btn__primary"
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default AddVariableModal;
